var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSentMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 172,
    viewBox: "0 0 172 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 86,
    r: 86,
    fill: "#F2FBFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.289 75H84.8017C83.1197 75 81.6174 76.0523 81.0425 77.633L67.9516 113.633C67.003 116.242 68.9349 119 71.7108 119H125.198C126.88 119 128.383 117.948 128.957 116.367L142.048 80.367C142.997 77.7582 141.065 75 138.289 75Z",
    fill: "#CAF0F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.289 66H76.8019C75.1199 66 73.6175 67.0523 73.0427 68.633L59.9518 104.633C59.0032 107.242 60.9351 110 63.711 110H117.198C118.881 110 120.383 108.948 120.958 107.367L134.049 71.367C134.997 68.7582 133.065 66 130.289 66Z",
    fill: "#ADE8F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5728 68.4622C73.2194 66.6838 74.9096 65.5 76.8018 65.5H130.289C133.412 65.5 135.586 68.603 134.518 71.5378L121.427 107.538C120.781 109.316 119.091 110.5 117.198 110.5H63.7109C60.5881 110.5 58.4147 107.397 59.4819 104.462L72.5728 68.4622ZM76.8018 66.5C75.3301 66.5 74.0155 67.4207 73.5126 68.8039L60.4217 104.804C59.5916 107.087 61.2821 109.5 63.7109 109.5H117.198C118.67 109.5 119.985 108.579 120.488 107.196L133.579 71.1961C134.409 68.9135 132.718 66.5 130.289 66.5H76.8018Z",
    fill: "#0096C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3838 85.1189C102.177 82.3535 120.36 73.6639 133 67.5L132 66.5L129.5 66H120.69H76.5L74.5 67L93.0418 84.5823C93.9426 85.4364 95.2635 85.6536 96.3838 85.1189Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.3819 65.5H129.549L132.246 66.0394L133.849 67.6421L133.219 67.9494C120.577 74.1143 102.393 82.8048 96.5991 85.5702C95.2895 86.1953 93.7466 85.9397 92.6978 84.9451L73.6382 66.8719L76.3819 65.5ZM76.618 66.5L75.3617 67.1281L93.3858 84.2195C94.1385 84.9331 95.2375 85.112 96.1683 84.6677C101.867 81.9479 119.546 73.4986 132.151 67.3578L131.753 66.9606L129.45 66.5H76.618Z",
    fill: "#0096C7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60 84L28 84",
    stroke: "#03045E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94L40 94",
    stroke: "#03045E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66 75H45",
    stroke: "#03045E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentMail);
export default __webpack_public_path__ + "static/media/SentMail.744e0fc6a7c3e0e3ada8bee96edf6abd.svg";
export { ForwardRef as ReactComponent };